// Campus photo for /colleges/university-of-illinois-urbana-champaign: CC BY-SA 4.0, by Beyond My Ken, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AFoellinger_Auditorium_University_of_Illinois_at_Urbana-Champaign_from_mid-quad.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-illinois-urbana-champaign/; credited under the photo.
const photo = {
    "slug": "university-of-illinois-urbana-champaign",
    "alt": "Foellinger Auditorium at the south end of the Main Quad at the University of Illinois Urbana-Champaign",
    "src": "/colleges/university-of-illinois-urbana-champaign/campus-1600.webp",
    "srcSmall": "/colleges/university-of-illinois-urbana-champaign/campus-800.webp",
    "srcMid": "/colleges/university-of-illinois-urbana-champaign/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-illinois-urbana-champaign/og.jpg",
    "title": "Foellinger Auditorium University of Illinois at Urbana-Champaign from mid-quad",
    "author": "Beyond My Ken",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AFoellinger_Auditorium_University_of_Illinois_at_Urbana-Champaign_from_mid-quad.jpg",
    "read": "2026-10-01"
};

export default photo;
